import { useEffect, useRef, useState } from "react";
import { useAssessment } from "../components/assessmentContext";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  LabelList,
  Legend,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { download_updated_excel, GetCombinedAssessmentResults } from "../apis/services/csaApi";
import { useNavigate } from "react-router-dom";
import en from "../json/en.json";
import ch from "../json/ch.json";
import * as XLSX from 'xlsx';

export default function Result() {
  const lId =
    localStorage.getItem("languageId") || "1";
  const assessmentId = localStorage.getItem("AssessmentId");
  const user_Type = localStorage.getItem("userType");
  const navigate = useNavigate();
  const navigateToQuestionnaire = (method, phase, groupName, enabler) => {
    navigate("/questionnaires", {
      state: {
        activeTab: allTabs.findIndex(tab => tab.topics === method),
        openPhase: phase,
        openGroup: groupName,
        openEnabler: enabler
      }
    });
    navigate("/questionnaires", {
      state: {
        activeTab: allTabs.findIndex(tab => tab.topics === method),
        openPhase: phase,
        openGroup: groupName,
        openEnabler: enabler
      }
    });
  };

  const { activeAssessment } = useAssessment();
  const [activeTab, setActiveTab] = useState(0);
  const [data, setData] = useState([]);
  const phaseRefs = useRef({});

  const [method, setMethod] = useState("");
  const [methodData, setMethodData] = useState([]);
  const [allTabs, setAllTabs] = useState([]);
  const [btbubble, setbtbubble] = useState(true);

  useEffect(() => {
    if (assessmentId != "1" && user_Type != "Bottler") {
      setbtbubble(false);
    } else {
      setbtbubble(true);
    }
  }, [assessmentId, user_Type]);

  useEffect(() => {
    getCombinedAssessmentResults();
  }, [localStorage.getItem("AssessmentId")]);

  const getCombinedAssessmentResults = async () => {
    try {
      const rawData = await GetCombinedAssessmentResults(
        "segmentation",
        localStorage.getItem("languageId"),
        localStorage.getItem("uId"),
        localStorage.getItem("AssessmentId")
      );
      // console.log("GetCombinedAssessmentResults", rawData[0]);

      if (rawData && rawData.length > 0) {
        const methods = [...new Set(rawData[0].map((item) => item.method))];
        const _total = lId === "1" ? en.total : ch.total
        setAllTabs([
          {
            topics:
              // "Total"
              _total
            , isCustom: true
          },
          ...methods.map((method) => ({ topics: method, isCustom: false })),
        ]);
        setMethodData(rawData[0]);
      }
    } catch (error) {
      console.error(`Error fetching attachments`, error);
    }
  };

  const triggerRef = useRef();
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(!entry.isIntersecting);
      },
      {
        root: null,
        threshold: 1,
        rootMargin: "-35px 0px 0px 0px",
      }
    );

    if (triggerRef.current) observer.observe(triggerRef.current);
    return () => observer.disconnect();
  }, []);

  const calculateChartData = (method) => {
    const _total = lId === "1" ? en.total : ch.total
    if (method ===
      // "Total"
      _total
    ) {
      const methodGroups = [...new Set(methodData.map((item) => item.method))];
      const total_all= methodGroups.map((method) => {
        const methodItems = methodData.filter((item) => item.method === method);
        // console.log("methodItems", methodItems);
        const currentTotal = methodItems.reduce(
          (sum, item) => sum + item.currentScore,
          0
        );
        // console.log("currentTotal", currentTotal);

        const desiredTotal = methodItems.reduce(
          (sum, item) => sum + item.desiredScore,
          0
        );
        // console.log("desiredTotal", desiredTotal);

        return { name: method, current: currentTotal, desired: desiredTotal };
      });
      console.log("total_all", total_all);
      
      return total_all
    } else {
      const methodItems = methodData.filter((item) => item.method === method);
      // console.log("asmethodItems", methodItems);

      // const enablers = [
      //   "Human Talent & Organization",
      //   "Standardized Process & Governance",
      //   "Tools & Technology",
      // ];


      const labels = lId === "1" ? en : ch;

      const enablers = [
        // labels.HumanTalentnOrganization,
        labels.StandardizedProcessnGovernance,
        labels.HumanTalentnOrganization,
        labels.ToolsnTechnology,
      ];


      // console.log("enablers", enablers);


      // return enablers.map((enabler) => {
      //   const enablerItems = methodItems.filter(
      //     (item) => item.enablers === enabler
      //   );
      //   const currentTotal = enablerItems.reduce(
      //     (sum, item) => sum + item.currentScore,
      //     0
      //   );
      //   // console.log("currentTotal", currentTotal);
      //   // console.log("enablerItems", enablerItems);
      //   const desiredTotal = enablerItems.reduce(
      //     (sum, item) => sum + item.desiredScore,
      //     0
      //   );
      //   // console.log("desiredTotal", desiredTotal);
      //   return {
      //     name: enabler,
      //     // name: enabler.split(" ")[0],
      //     current: currentTotal,
      //     desired: desiredTotal,
      //   };
      // });

      const methodWise = enablers.map((enabler) => {
        const enablerItems = methodItems.filter(
          (item) => item.enablers === enabler
        );
        const currentTotal = enablerItems.reduce(
          (sum, item) => sum + item.currentScore,
          0
        );
        // console.log("currentTotal", currentTotal);
        // console.log("enablerItems", enablerItems);
        const desiredTotal = enablerItems.reduce(
          (sum, item) => sum + item.desiredScore,
          0
        );
        // console.log("desiredTotal", desiredTotal);
        return {
          name: enabler,
          // name: enabler.split(" ")[0],
          current: currentTotal,
          desired: desiredTotal,
        };
      });
      console.log("methodWise", methodWise);

      return methodWise
    }
  };

  const renderCustomLegend = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "2rem",
        marginBottom: "1rem",
        marginTop: "2rem",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        <div
          style={{ width: 14, height: 14, backgroundColor: "#3c3c3a" }}
        ></div>
        <span
          style={{
            color: "#3c3c3a",
            fontFamily: "TCCC-UnityTextPC-Bold",
            fontSize: 16,
          }}
        >
          {lId === "1" ? en.current : ch.current}
        </span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        <div
          style={{ width: 14, height: 14, backgroundColor: "#f40009" }}
        ></div>
        <span
          style={{
            color: "#3c3c3a",
            fontFamily: "TCCC-UnityTextPC-Bold",
            fontSize: 16,
          }}
        >
          {lId === "1" ? en.desired : ch.desired}
        </span>
      </div>
    </div>
  );

  const groupByPhase = (method) => {
    const methodItems = methodData.filter((item) => item.method === method);
    const phases = [...new Set(methodItems.map((item) => item.phase))];

    return phases.map((phase) => {
      const phaseItems = methodItems.filter((item) => item.phase === phase);
      const groups = [...new Set(phaseItems.map((item) => item.groupName))];

      const groupScores = groups.map(group => {
        const groupItems = phaseItems.filter(item => item.groupName === group);


        const labels = lId === "1" ? en : ch;



        // const enablerScores = [
        //   "Human Talent & Organization",
        //   "Standardized Process & Governance",
        //   "Tools & Technology"
        // ].map(enabler => {
        //   const items = groupItems.filter(item => item.enablers === enabler);
        //   return {
        //     current: items.reduce((sum, item) => sum + item.currentScore, 0),
        //     desired: items.reduce((sum, item) => sum + item.desiredScore, 0)
        //   };
        // });

        const enablers = [
          labels.HumanTalentnOrganization,
          labels.StandardizedProcessnGovernance,
          //  labels.HumanTalentnOrganization,
          labels.ToolsnTechnology,
        ];

        const enablerScores = enablers.map(enabler => {
          const items = groupItems.filter(item => item.enablers === enabler);
          return {
            current: items.reduce((sum, item) => sum + item.currentScore, 0),
            desired: items.reduce((sum, item) => sum + item.desiredScore, 0)
          };
        });

        const groupTotal = {
          current: enablerScores.reduce((sum, score) => sum + score.current, 0),
          desired: enablerScores.reduce((sum, score) => sum + score.desired, 0)
        };

        return {
          group,
          enablerScores,
          groupTotal
        };
      });

      const phaseTotal = {
        current: groupScores.reduce((sum, group) => sum + group.groupTotal.current, 0),
        desired: groupScores.reduce((sum, group) => sum + group.groupTotal.desired, 0)
      };

      return {
        phase,
        groupScores,
        phaseTotal
      };
    });
  };

  const renderCustomizedLabel = (props) => {
    const { x, y, width, value } = props;
    const radius = 10;

    return (
      <g>
        <text
          x={x + width / 2}
          y={y - radius}
          fill="#3c3c3a"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={14}
          fontFamily="TCCC-UnityTextPC-Bold"
        >
          {value}
        </text>
      </g>
    );
  };



  // const handleExport = () => {
  //   let worksheetData = [];

  //   if (activeTab === 0) {
  //     // Total tab
  //     worksheetData = calculateChartData(allTabs[activeTab]?.topics).map(row => ({
  //       Name: row.name,
  //       'Current Score': row.current,
  //       'Desired Score': row.desired
  //     }));
  //   } else {
  //     // Method tab
  //     groupByPhase(allTabs[activeTab]?.topics).forEach(phase => {
  //       phase.groupScores.forEach(group => {
  //         group.enablerScores.forEach((enabler, idx) => {
  //           const enablerName = [
  //             "Human Talent & Organization",
  //             "Standardized Process & Governance",
  //             "Tools & Technology"
  //           ][idx];
  //           worksheetData.push({
  //             Phase: phase.phase,
  //             Group: group.group,
  //             Enabler: enablerName,
  //             'Current Score': enabler.current,
  //             'Desired Score': enabler.desired
  //           });
  //         });
  //       });
  //     });
  //   }

  //   const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Results");
  //   XLSX.writeFile(workbook, `assessment_results_${new Date().toISOString().split('T')[0]}.xlsx`);
  // };


  const handleExport = async () => {
    try {
      const response = await download_updated_excel(localStorage.getItem("userName"), localStorage.getItem("AssessmentId"));
      // console.log("xl data", response);
      if (!response) {
        throw new Error('No response received');
      }
      // const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(response);

      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = 'Updated_Assessment_Report.xlsx';
      document.body.appendChild(a);
      a.click();

      // Clean up
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(a);

      // setData(response || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      // setData([]);
    }
  };

  return (
    <div className="wrapper">

      <div className="section-questions-result">

        <div className="w-full flex justify-end gap-4">
          {/* <button
            onClick={handleExport}
            className="bg-[#f40009] text-white text-2xl px-4 py-2 rounded-md hover:bg-[#d90008] transition-colors"
          >
            {localStorage.getItem("AssessmentText")} {lId === "1" ? en.report : ch.report}
          </button> */}


          {btbubble == false ?
            null :
            <button
              onClick={() => navigate("/OpportunityBubbleChart")}
              className="bg-[#3c3c3a] text-white text-2xl px-4 py-2 rounded-md hover:bg-[#2e2e2c] transition-colors"
            >
              {lId === "1" ? "Opportunity Chart" : "机会图表"}
            </button>
          }
        </div>
        <h1 className="main-heading">
          {activeTab === 0
            ? `${lId === "1" ? en.total : ch.total} ${localStorage.getItem("AssessmentText")} ${lId === "1" ? en.result : ch.result} ${lId === "1" ? en.breakdown : ch.breakdown}`
            : `${allTabs[activeTab]?.topics} ${localStorage.getItem("AssessmentText")} ${lId === "1" ? en.result : ch.result} ${lId === "1" ? en.breakdown : ch.breakdown}`}

        </h1>



        <div className="methods-container-result">
          {allTabs.map((tab, index) => (
            <button
              key={index}
              onClick={() => setActiveTab(index)}
              className={`methods ${activeTab === index ? "active" : ""}`}
            >
              <p>{tab.topics}</p>
            </button>
          ))}
        </div>

        {/* Chart */}
        <div style={{ width: "100%", height: 525 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={calculateChartData(allTabs[activeTab]?.topics)}
              style={{ background: "transparent" }}
              margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
            >
              <XAxis
                dataKey="name"
                stroke="#3a3a3a"
                tickLine={false}
                tick={{
                  fill: "#3c3c3a",
                  fontSize: 14,
                  fontFamily: "TCCC-UnityTextPC-Bold",
                }}
              />
              <YAxis
                stroke="#3a3a3a"
                tickLine={false}
                tick={{
                  fill: "#3c3c3a",
                  fontSize: 14,
                  fontFamily: "TCCC-UnityTextPC-Bold",
                }}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: '#fff',
                  border: '1px solid #3c3c3a',
                  borderRadius: '4px',
                }}
                itemStyle={{
                  color: '#3c3c3a',
                  fontFamily: 'TCCC-UnityTextPC-Bold',
                }}
              />
              <Legend content={renderCustomLegend} />
              <Bar dataKey="current" fill="#3c3c3a" barSize={30} label={renderCustomizedLabel}>
                {calculateChartData(allTabs[activeTab]?.topics).map(
                  (entry, index) => (
                    <Cell key={`current-${index}`} fill="#3c3c3a" />
                  )
                )}
              </Bar>
              <Bar dataKey="desired" fill="#f40009" barSize={30} label={renderCustomizedLabel}>
                {calculateChartData(allTabs[activeTab]?.topics).map(
                  (entry, index) => (
                    <Cell key={`desired-${index}`} fill="#f40009" />
                  )
                )}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div ref={triggerRef} className="h-[1px]" />

        {/* Table for specific method (not Total) */}
        {activeTab !== 0 && (
          <>
            {/* Sticky Header */}
            <div
              className={`table-overview-result ${isSticky ? "sticky" : ""}`}
            >
              {/* <p>
                {lId === "1" ? en.hr : ch.hr} <span>({lId === "1" ? en.score : ch.score})</span>
              </p> */}
              <p style={{ marginLeft: lId === "1" ? "12rem" : "14rem" }}>
                {lId === "1" ? en.process : ch.process} <span>({lId === "1" ? en.score : ch.score})</span>
              </p>
              <p>
                {lId === "1" ? en.hr : ch.hr} <span>({lId === "1" ? en.score : ch.score})</span>
              </p>
              <p style={{ marginLeft: lId === "1" ? "12rem" : "15rem" }}>
                {lId === "1" ? en.it : ch.it} <span>({lId === "1" ? en.score : ch.score})</span>
              </p>
              <p style={{ marginRight: lId === "1" ? "14.5rem" : "15.5rem", marginLeft: lId === "1" ? "13.5rem" : "14.5rem" }}>
                {lId === "1" ? en.total : ch.total} <span>({lId === "1" ? en.score : ch.score})</span>
              </p>
            </div>

            {/* Table Content */}
            <div className="methods-content-container-result">
              <ul>
                {groupByPhase(allTabs[activeTab]?.topics).map((phaseData, idx) => (
                  <li key={idx} ref={(el) => (phaseRefs.current[phaseData.phase] = el)}>
                    <div>
                      <button>
                        <p className="phase">{phaseData.phase}</p>
                      </button>

                      <div className="group-name-container">
                        {phaseData.groupScores.map((group, groupIdx) => (
                          <div className="table-overview" key={groupIdx}>
                            <p>{group.group}</p>
                            {/* <p
                              className="cursor-pointer hover:text-[#f40009]"
                              onClick={() => {
                                // console.log("navigateToQuestionnaire", allTabs, allTabs[activeTab]?.topics, phaseData.phase, group.group, "Human Talent & Organization");
                                navigateToQuestionnaire(
                                  allTabs[activeTab]?.topics,
                                  phaseData.phase,
                                  group.group,
                                  // "Human Talent & Organization"
                                  lId === "1" ? en.HumanTalentnOrganization : ch.HumanTalentnOrganization
                                )
                              }}>
                              {group.enablerScores[0].current} | {group.enablerScores[0].desired}
                            </p> */}
                            <p
                              className="cursor-pointer hover:text-[#f40009]"
                              onClick={() => {
                                // console.log("navigateToQuestionnaire", allTabs[activeTab]?.topics, phaseData.phase, group.group, "Standardized Process & Governance");
                                navigateToQuestionnaire(
                                  allTabs[activeTab]?.topics,
                                  phaseData.phase,
                                  group.group,
                                  // "Standardized Process & Governance"
                                  lId === "1" ? en.StandardizedProcessnGovernance : ch.StandardizedProcessnGovernance
                                )
                              }}>
                              {group.enablerScores[1].current} | {group.enablerScores[1].desired}
                            </p>
                            <p
                              className="cursor-pointer hover:text-[#f40009]"
                              onClick={() => {
                                // console.log("navigateToQuestionnaire", allTabs, allTabs[activeTab]?.topics, phaseData.phase, group.group, "Human Talent & Organization");
                                navigateToQuestionnaire(
                                  allTabs[activeTab]?.topics,
                                  phaseData.phase,
                                  group.group,
                                  // "Human Talent & Organization"
                                  lId === "1" ? en.HumanTalentnOrganization : ch.HumanTalentnOrganization
                                )
                              }}>
                              {group.enablerScores[0].current} | {group.enablerScores[0].desired}
                            </p>
                            <p
                              className="cursor-pointer hover:text-[#f40009]"
                              onClick={() => {
                                // console.log("navigateToQuestionnaire", allTabs[activeTab]?.topics, phaseData.phase, group.group, "Tools & Technology");
                                navigateToQuestionnaire(
                                  allTabs[activeTab]?.topics,
                                  phaseData.phase,
                                  group.group,
                                  // "Tools & Technology"
                                  lId === "1" ? en.ToolsnTechnology : ch.ToolsnTechnology
                                )
                              }
                              }>
                              {group.enablerScores[2].current} | {group.enablerScores[2].desired}
                            </p>
                            <p>
                              {group.groupTotal.current} | {group.groupTotal.desired}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </div>
    </div>
  );
}